
import RcDomainMap from "@/domain/common/RcDomainMap.js";

import Note from './Note.js';
import NoteUtils from './NoteUtils.js';

export default class NoteMap extends RcDomainMap {
  
  static MODEL_NAME = "VehicleScheduleQuestionNoteMap";
  
  constructor(domain, data) {
    super(domain, data);
  }

  find() {
    var keys = this.keys();
    var found = new NoteMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.notes().findById(key);
      var item = new Note(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    
    return found;
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getNote(key);
      values.push(item);
    }
    return values;
  }
  
  sort() {
    var sorted = [];
    sorted = this.list();
    sorted = sorted.sort(NoteUtils.SortByPosition);
    return sorted;
  }
  
  // The notes held in the map, ordered by their position as a number ("2" before "10")
  // and then by id. A note the map holds in full - one the editor wrote - is read as it
  // is; a bare link, as the checklist list and save responses send them, is read from
  // the notes those responses carry (domain.notes()).
  //
  // Each note is a copy of what the map holds, so reading never changes the stored
  // record (the Note constructor would add its @class to it). Write a changed note back
  // with add() and the map back to its owner.
  sortByPosition() {
    return this.keys()
      .map(key => this._readNote(key))
      .sort((a, b) => (a.positionNumber() - b.positionNumber()) || (a.id() < b.id() ? -1 : (a.id() > b.id() ? 1 : 0)));
  }
  
  // Whether any note in the map says anything.
  hasValues() {
    return this.keys().some(key => this._readNote(key).hasValue());
  }

  _readNote(key) {
    var value = super.get(key);
    if (value != null && typeof value === 'object' && !Array.isArray(value)) {
      value = Object.assign({}, NoteMap._isLink(value) ? this._storedNote(key) : null, value);
    }
    return new Note(this.domain, value);
  }

  // A link carries only its id and class: no position and no value.
  static _isLink(value) {
    return !(Note.Fields.POSITION in value) && !(Note.Fields.VALUE in value);
  }

  _storedNote(key) {
    var notes = this.domain && this.domain.notes ? this.domain.notes() : null;
    var stored = notes ? notes.findById(key) : null;
    return stored && !stored.isNew() ? stored.data : null;
  }
  
  getNote(key) {
    var value = super.get(key);
    return new Note(this.domain, value);
  }
  
  copy() {
    var data = this._copy();
    return new NoteMap(this.domain, data);
  }
}